import { render, staticRenderFns } from "./ConfigureWhatsApp.vue?vue&type=template&id=68e0fa57&scoped=true"
import script from "./ConfigureWhatsApp.vue?vue&type=script&lang=js"
export * from "./ConfigureWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./ConfigureWhatsApp.vue?vue&type=style&index=0&id=68e0fa57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e0fa57",
  null
  
)

export default component.exports